import FleetDashboardView from "../../components/FleetDashboardView";

FleetDashboardScreen.propTypes = {};

function FleetDashboardScreen(props) {
    return (
        <div className="container-fluid px-0">
            <FleetDashboardView />
        </div>
    );
}

export default FleetDashboardScreen;
